<template>
  <nav>
    <router-link :to="{name: 'assignments'}" class="logo">
      <sprite name="logoBlasts"></sprite>
    </router-link>
  </nav>
</template>

<script>
  export default {
    name: 'PrimaryNavigation'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  $nav-spacing: 2.2rem;

  .logo {
    display:block; margin-right:$nav-spacing;
    svg {
      width:20rem;
    }
  }

  nav {
    display:flex; align-items:center; z-index:6;
  }


  /*



  nav {
    display:flex; align-items:center;
  }

  ul {
    @include list-style-reset;
  }

  .nav {
    display:flex; font-size:16px; line-height:1.2; margin-left:40px;
    & > li+li {
      margin-left:25px;
    }
    &__expand {
      position:relative;
      &:after {
        content:''; width:0; height:0; margin-left:5px; border-left:5px solid transparent; border-right:5px solid transparent; border-top:5px solid $color-gray-darkest; position:absolute; top:50%; transform:translateY(-50%);
      }
    }
    &__inner {
      display:none;
    }
  }

  a {
    text-decoration:none; color:$color-gray-darkest;
  }

  button {
    @include button-reset;
  }*/

</style>



// WEBPACK FOOTER //
// src/components/AppHeader/PrimaryNavigation.vue